const translations = {
  lt: {
    logo: '/images/logo.png',
    logoAlt: 'Gricius Logistics Logo',
    header: {
      menu: {
        home: 'Pagrindinis',
        carrier: 'Darbo skelbimai',
        news: 'Naujienos',
      },
    },
    footer: {
      copyright: 'Gricius Logistics. All rights reserved.',
    },
    hero: {
      img: '/images/hero-banner.jpg',
      imgAlt: 'Hero banner',
      text: 'Vieni didžiausių vežėjų<br><span>Baltijos šalyse</span>',
    },
    pages: {
      home: {
        heading: 'Karjera Gricius Logistics įmonėje',
        content:
          'Aukime kartu su Gricius Logistics!<br/><br/>Norite pažinti transporto pasaulį arba jau esate pažįstami ir norite gauti neįkainojamos patirties ir galimybių - junkitės prie mūsų komandos ir suteikite galimybę mums, pažinti jus.<br/><br/>Į mūsų komandą taip pat kviečiame  jungtis paskutiniame logistikos vadybos kurse besimokančius studentus, o taip pat  suteikiame visas sąlygas žmonėms, norintiems keisti darbo pobūdį ar sritį.<br/><br/>Mūsų įmonių grupei  30 metų. Esame didelė, net trisdešimties metų darbo patirtį turinti įmonė ir viena didžiausių transporto ir logistikos įmonių Lietuvoje. Todėl galime garantuoti jums stabilumą, ilgalaikę patirtį ir darbą jaunatviškame kolektyve, kuriame draugiški, mėgstantys iššūkius ir inovacijas žmonės.<br/><br/>Tobuliname programas, kurios palengvina mūsų kasdienį darbą. Karjeros galimybės - tai mūsų akivaizdi kasdienybė - didžioji dalis vadovų savo darbą įmonėje pradėjo nuo paprasčiausių pareigų.<br/><br/>Matome, girdime ir įsiklausome į kiekvieno dirbančiojo nuomonę, nes mums svarbu, kaip jūs jaučiatės kolektyve ir kokią atmosferą įmonėje mes kuriame kartu.',
      },
      carrier: {
        heading: 'Darbo skelbimai',
      },
      carrierPost: {
        position: 'pozicija',
        company: 'Įmonė',
        city: 'Miestas',
        salary: 'Atlyginimas',
        published: 'Patalpintas',
        contactFormHeading: 'Kandidatuokite užpildę žemiau esančią formą',
        name: 'Vardas',
        lastName: 'Pavardė',
        phone: 'Tel. nr',
        email: 'El. paštas',
        inputText: 'Įveskite...',
        attachCv: 'Prisekite savo CV',
        selectedFile: 'Pasirinktas failas',
        notSelectedFile: 'Nepasirinktas joks failas',
        sendButton: 'Kandidatuoti',
        required: '*',
        views: 'Peržiūrėtas',
        candidate: 'Kandidatavo',
        successMessage: 'Sėkmingai kandidatavote!',
      },
      news: {
        heading: 'Naujienos',
        empty: 'Kol kas naujienų nėra...',
      },
    },
    meta: {
      home: {
        title: 'Vieni didžiausių vežėjų Baltijos šalyse!',
      },
      carrier: {
        title: 'Karjera',
      },
      news: {
        title: 'Naujienos',
      },
    },
    global: {
      brutto: 'neatskaičius mokesčių',
      netto: 'į rankas',
      company1: 'UAB Gricius Logistics',
      company2: 'A. Griciaus ATĮ',
      somethingWrong: 'Something went wrong.',
      from: 'Nuo',
      euroMonth: '€/mėn',
      privacy:
        'Spausdami mygtuką kandidatuoti Jūs sutinkate su mūsų įmonės <a target="_blank" href="' +
        process.env.REACT_APP_SITE_URL +
        '/privatumo-politika.pdf">privatumo politika</a> ir duomenų tvarkymu.',
    },
    routes: {
      carrier: 'jobs',
      news: 'news',
    },
  },
  en: {
    logo: '/images/logo.png',
    logoAlt: 'Gricius Logistics Logo',
    header: {
      menu: {
        home: 'Home',
        carrier: 'Carrier',
        news: 'News',
      },
    },
    footer: {
      copyright: 'Gricius Logistics. All rights reserved.',
    },
    hero: {
      img: '/images/hero-banner.jpg',
      imgAlt: 'Hero banner',
      text: 'One of the bigest carriers<br><span>in Baltics states</span>',
    },
    pages: {
      home: {
        heading: 'About Gricius Logistics',
        content:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.<br/><br/>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.<br/><br/>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.<br/><br/>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.<br/><br/>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      },
      carrier: {
        heading: 'Job offers',
      },
      carrierPost: {
        position: 'position',
        company: 'Company',
        city: 'City',
        salary: 'Salary',
        published: 'Published',
        contactFormHeading: 'Apply by filling out the form below',
        name: 'Name',
        lastName: 'Last name',
        phone: 'Phone',
        email: 'Email',
        inputText: 'Input...',
        attachCv: 'Attach your CV',
        selectedFile: 'Selected file',
        notSelectedFile: 'No file selected',
        sendButton: 'Apply',
        required: '*',
        views: 'Views',
        candidate: 'Candidates',
        successMessage: 'Your application is successful!',
      },
      news: {
        heading: 'News',
        empty: 'No news yet...',
      },
    },
    meta: {
      home: {
        title: 'One of the bigest carriers in Baltics states!',
      },
      carrier: {
        title: 'Carrier',
      },
      news: {
        title: 'News',
      },
    },
    global: {
      brutto: 'brutto',
      netto: 'netto',
      company1: 'UAB Gricius Logistics',
      company2: 'A. Griciaus ATĮ',
      somethingWrong: 'Something went wrong.',
      from: 'From',
      euroMonth: '€/month',
    },
    routes: {
      carrier: 'jobs',
      news: 'news',
    },
  },
  ru: {},
};

export default translations;
